import React from 'react';
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import DownIcon from '../../assets/icons/down-w.svg';
import UpIcon from '../../assets/icons/up-w.svg';
import Tab from './tabs/Tab';

const Wrapper = styled(Grid)`
  cursor: pointer;
  background-color: ${({theme}) => theme.primaryColor};
  color: ${({theme}) => theme.white};
  height: 100%;
  align-items: center;
`;

const Text = styled(Tab).attrs({selected: true})`
  text-align: left;
`;

const Value = styled.span`
  font-weight: normal;
`;

const IconUnit = styled(Grid.Unit)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.img`
  height: ${({theme}) => theme.spacingVertical(2)};
`;

const DropDown = ({label, value, active}) => (
  <Wrapper>
    <Grid.Unit size={0.85}>
      <Text>
        {label}: <Value>{value}</Value>
      </Text>
    </Grid.Unit>
    <IconUnit size={0.1}>
      <Icon src={active ? UpIcon : DownIcon} />
    </IconUnit>
  </Wrapper>
);

export default DropDown;
